import { consumirServicioEncirptacion } from "api";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import {
  ambienteAplicacion,
  urlActualizarCotitzacionAP,
  urlCatalogosCotizadorMex,
  urlResumenCotizadorMex,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useCustomToast from "hooks/useCustomToasts";
import { Button } from "primereact/button";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";
import DynamicForm from "../../components/DynamicForm";
import { RCP } from "./constantes/general";

export const RCPPreguntas = ({
  qParams: { idCotizacion },
  history,
  dataUsuario: { cliCodigoCore },
}) => {
  useNavbarContext(PRODUCTOS.RCP);
  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const { addWarningToast } = useCustomToast();
  const [bloquear, setBloquear] = useState(false);

  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, reset } = methods;
  const values = methods.getValues();

  useEffect(() => {
    let completo = true;
    const preguntas = Object.entries(values || {});
    if (preguntas.length > 0) {
      preguntas.map(([_, value]) => {
        if (value === undefined) {
          completo = false;
        }
      });
      setBloquear(!completo);
    }
  }, [values]);

  const onSubmit = async (data) => {
    const keys = Object.entries(data);
    let continuar = true;
    const arrPreguntas = keys.map(([name, value]) => {
      const pregunta = catalogo?.preguntas?.secciones[0]?.campos?.find(
        (preg) => preg.name === name
      );
      if (value === false) {
        continuar = false;
      }
      return {
        id: name,
        label: pregunta?.label,
        respuesta: value ? "SI" : "NO",
        orden: pregunta?.orden || 1,
      };
    });

    setLoading(true);
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: RCP.prodCodigoCore,
      pasoCodigo: "guardadoPreguntas",
      items: {
        cotCodigo: idCotizacion || "",
        usuCotiza: { usuCodigo: cliCodigoCore || "" },
        datosCotizacion: {
          preguntas: arrPreguntas.sort((a, b) => a?.orden - b?.orden),
        },
      },
    };

    let res;
    res = await consumirServicioEncirptacion(urlActualizarCotitzacionAP, Data);
    console.log(res);
    if (res.transaccion) {
      console.log(data);
      history.push(`${RCP.urls.planes}?idCotizacion=${idCotizacion}`);
    } else {
      console.log("DATOS RESET", data);
      reset(data);
      try {
        if (!continuar) {
          addWarningToast(
            catalogo?.preguntasComprobacion ||
              'Si respondió "NO" a cualquiera de las preguntas anteriores, AIG México no puede otorgar el Seguro bajo las condiciones descritas. Por favor consulte a su Asesor de Seguros para obtener una propuesta alternativa o contáctenos a (correo)'
          );
        } else if (res?.errorDescripcion?.mensajeValidacion) {
          addWarningToast(res?.errorDescripcion?.mensajeValidacion, {
            autoDismiss: false,
          });
        } else {
          if (typeof res.errorDescripcion === "string") {
            addWarningToast(res.errorDescripcion, { autoDismiss: false });
          } else {
            res.errorDescripcion.forEach((msg) =>
              addWarningToast(msg, { autoDismiss: false })
            );
          }
        }
      } catch (e) {
        addWarningToast("Error desconocido", { autoDismiss: false });
      }
    }
    setLoading(false);
  };

  const loadData = useCallback(async () => {
    setLoading(true);
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };
    try {
      let resResumen;
      resResumen = await consumirServicioEncirptacion(
        urlResumenCotizadorMex,
        DataResumen
      );
      if (resResumen?.transaccion) {
        const preLoad = resResumen?.cotConsulta?.prodDatos[0]?.preguntas;
        console.log("PRELOAD", resResumen);
        const preguntas = {};
        preLoad.forEach((pre) => (preguntas[pre.id] = pre.respuesta === "SI"));
        setBloquear(false);

        reset({ ...preguntas });
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  }, [idCotizacion, reset]);

  const onSubmitError = (values) => {
    addWarningToast("Complete todas las preguntas");
  };

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const Body = {
        ambiente: ambienteAplicacion,
        datosCotizador: {
          prodCodigo: RCP.prodCodigoCore,
          catPasoCodigo: "preguntas",
          cotCodigo: idCotizacion,
          usuCotiza: { usuCodigo: cliCodigoCore || "" },
        },
      };
      const res = await consumirServicioEncirptacion(urlCatalogosCotizadorMex, Body);
      console.log(res);
      if (res?.transaccion && res?.catalogo) {
        if (res?.catalogo?.titulo) {
          res.catalogo.preguntas.titulo = res?.catalogo?.titulo;
        }
        if (res?.catalogo?.subtitulo) {
          res.catalogo.preguntas.subtitulo = res?.catalogo?.subtitulo;
        }
        setCatalogo(res?.catalogo);
      }
      loadData();
    } catch (error) {
      setLoading(false);
    }
  }, [idCotizacion, loadData]);

  const regresar = () => {
    history.push(`${RCP.urls.datosAsegurado}?idCotizacion=${idCotizacion}`);
  };

  useEffect(() => {
    if (idCotizacion) {
      getData();
    } else {
      history.push(`${RCP.urls.datosAsegurado}`);
    }
  }, [getData, idCotizacion, history]);

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.RCP].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.RCP].breadCrumbPasosCotizacion[2]}
            styleimg='height200px mr-3'
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.RCP]?.pasosCotizacion}
          />

          <FormProvider {...methods}>
            <form
              id='form-preguntas'
              onSubmit={handleSubmit(onSubmit, onSubmitError)}
              className='row d-flex flex-wrap justify-content-center'>
              <div className='col-10 d-flex justify-content-center'>
                {catalogo?.preguntas && (
                  <DynamicForm {...catalogo.preguntas} resources={catalogo} />
                )}
              </div>
              <div className='col-12 d-flex justify-content-center mt-5'>
                <div className='col-lg-2 col-md-3 col-sm-12 d-flex justify-content-center'>
                  <Button
                    label='ATRÁS'
                    onClick={() => {
                      regresar();
                    }}
                    className='btn-primary text-center w-100'></Button>
                </div>
                <div className='col-lg-2 col-md-3 col-sm-12 d-flex justify-content-center'>
                  <Button
                    disabled={bloquear}
                    label='CONTINUAR'
                    form='form-preguntas'
                    type='submit'
                    className='btn-primary text-center w-100'></Button>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
